import * as Yup from 'yup';

const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Invalid email")
});

export default forgotPasswordSchema;